// Opaque keys to ensure that permission tokens cannot be faked. This file is
// not publicly exposed.
export const SELF = Symbol('self');
export const VERIFIED = Symbol('verified');

//# sourceMappingURL=symbols.js.map